import React, { lazy } from 'react';
import EditorLoadableWrapper from '../../EditorLoadableWrapper';
import { EditorProps } from '../../types';
import retry from '../../../utils/chunkRetry';

const LoadableEditor = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "editor_v3", webpackPrefetch: true */
        './Gallection'
      )
  )
);

const GallectionEditorLoadable: React.FC<
  Omit<EditorProps, 'extensionConfig' | 'presetId'> & { compact?: boolean }
> = props => {
  return (
    <EditorLoadableWrapper>
      <LoadableEditor {...props} />
    </EditorLoadableWrapper>
  );
};
GallectionEditorLoadable.displayName = 'GallectionEditor';

export default GallectionEditorLoadable;
